// extracted by mini-css-extract-plugin
export default {"error-message":"InputError_error-message__ACp+u"};